var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QPageContainer',[_c('QPage',{staticClass:"row q-pt-xl justify-center"},[_c('SAISpinner',{attrs:{"size":"xl"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }